import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useAuthContext } from "../../../hooks/useAuthContext";
import ClasseDetailComponent from "./components/ClasseDetailComponent";
import classesAPI from "../../../services/classes";
import MeaPageTitle from "../../../components/MeaPageTitle";
import { useRef, useState } from "react";
import { TabMenu } from "primereact/tabmenu";
import StudentsListComponent from "../students/components/StudentsListComponent";
import ScheduleListComponent from "../schedule/components/ScheduleListComponent";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import SessionsListComponent from "../sessions/components/SessionsListComponent";
import UpdateClasseModal from "./components/UpdateClasseModal";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { PERMISSION_TRAINING_CLASSES } from "../../../permissions";
import { SelectButton } from "primereact/selectbutton";
import { ToFormatedShortISODate } from "../../../utils/dates";
import { useEffect, useMemo } from "react";

const ClasseDetailPage = () => {

  const { training } = useLoaderData();
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const classeId = params.classeId;
  //
  const classeQuery = classesAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    classeId
  );
  const classeObj = classeQuery?.data?.data;
  //
  //
  // states
  const [activeItem, setActiveItem] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [showPassingColumns, setShowPassingColumns] = useState(false);
  const listRef = useRef();
  const monthOptions = useMemo(() => {
    const startDate = training?.start_courses_date ? new Date(training.start_courses_date) : new Date();
    const endDate = training?.end_courses_date ? new Date(training.end_courses_date) : new Date();
    const months = [];
    const loopDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);

    while (loopDate <= endDate) {
      const year = loopDate.getFullYear();
      const month = loopDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      months.push({
        label: firstDay.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }),
        value: `${year}-${String(month + 1).padStart(2, "0")}`,
        start_date: ToFormatedShortISODate(firstDay),
        end_date: ToFormatedShortISODate(lastDay),
      });

      loopDate.setMonth(loopDate.getMonth() + 1);
    }

    if (months.length === 0) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      months.push({
        label: firstDay.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }),
        value: `${year}-${String(month + 1).padStart(2, "0")}`,
        start_date: ToFormatedShortISODate(firstDay),
        end_date: ToFormatedShortISODate(lastDay),
      });
    }

    return months;
  }, [training?.end_courses_date, training?.start_courses_date]);

  const currentMonthValue = useMemo(() => {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
  }, []);

  const selectedMonthData = monthOptions.find((month) => month.value === selectedMonth) || monthOptions[0];

  useEffect(() => {
    if (!monthOptions[0]) {
      return;
    }

    if (!selectedMonth) {
      const defaultMonth =
        monthOptions.find((month) => month.value === currentMonthValue) || monthOptions[0];
      setSelectedMonth(defaultMonth.value);
      return;
    }

    const selectedMonthStillAvailable = monthOptions.some((month) => month.value === selectedMonth);
    if (!selectedMonthStillAvailable) {
      setSelectedMonth(monthOptions[0].value);
    }
  }, [currentMonthValue, monthOptions, selectedMonth]);
  // params
  const items = [
    { label: "Elèves", icon: "pi pi-users" },
    { label: "Programme de la semaine", icon: "pi pi-clock" },
    { label: "Séances de cours", icon: "pi pi-calendar" },
  ];
  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        title={<MeaPageTitle prefix={"Classe:"} title={classeObj?.name} />}
        actions={[
          {
            label: showPassingColumns
              ? "Masquer les avis de passage"
              : "Afficher les avis de passage",
            icon: showPassingColumns ? "pi pi-eye-slash" : "pi pi-eye",
            command: () => {
              setShowPassingColumns((currentValue) => !currentValue);
            },
          },
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_CLASSES.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  classeQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_CLASSES.DELETE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_CLASSES.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer cette classe?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  classesAPI
                    .DeleteOne(schoolId, trainingId, accessToken, classeId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: classeObj?.name + " Supprimé!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/classes"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <ClasseDetailComponent classe={classeObj} />
        <UpdateClasseModal ref={updateModalRef} classe={classeObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />

        <div className="mt-5">
          <TabMenu
            model={items}
            activeIndex={activeItem}
            onTabChange={(e) => {
              setActiveItem(e.index);
            }}
          />
          {activeItem === 0 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <StudentsListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ classe_id: classeObj?.id }}
                showAddButton={false}
                showFilterButton={false}
                showSlotChangeColumn={false}
                selectedFields={{
                  level: false,
                  classe: false,
                  passing: showPassingColumns,
                  observation: showPassingColumns,
                  status: false,
                  allergies: true,
                  authorized_take_photo: true,
                  authorized_back_alone: true,
                }}
              />
            </MeaLoadingContent>
          )}
          {activeItem === 1 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <ScheduleListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ classe_id: classeObj?.id }}
                showAddButton={false}
                showFilterButton={false}
                selectedFields={{
                  classe: false,
                }}
              />
            </MeaLoadingContent>
          )}
          {activeItem === 2 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <>
                <div className="mt-3 mb-3">
                  <SelectButton
                    value={selectedMonth || selectedMonthData?.value}
                    options={monthOptions}
                    optionLabel="label"
                    optionValue="value"
                    onChange={(e) => setSelectedMonth(e.value)}
                    className="w-full flex-wrap"
                  />
                </div>
                <SessionsListComponent
                  key={`${classeId}-${selectedMonthData?.value || "all"}`}
                  ref={listRef}
                  schoolId={schoolId}
                  trainingId={trainingId}
                  showAddButton={false}
                  showFilterButton={false}
                  showAllSessions={true}
                  filter={{
                    classe_id: classeObj?.id,
                    start_date: selectedMonthData?.start_date,
                    end_date: selectedMonthData?.end_date,
                  }}
                  selectedFields={{
                    presence: true,
                    level: false,
                    classe: false,
                  }}
                />
              </>
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};
export default ClasseDetailPage;
